/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 홍보 결과 목록 > 관심표명자 등록 버튼
 * 버전 : 1.0
 * 파일명 : ButtonResultAddInterest.ts
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-18, 강동형 : 관심표명자 등록 실패시 이동 안하게 조정
 * 수정 : 2026-02-05, 강동형 : 학과 등록 기능 추가
 * ================================================================ */
import React, { useEffect } from 'react'
import { NextButton } from '../common/CommonStyled'
import { usePromoAddInterest } from 'src/stores/PromoStore'
import { postInterestStudent } from 'src/api/Promo'
import { format } from 'date-fns'
import { PromoResultType } from 'src/pages/PromoResultPage';

interface Props{
  setTab : React.Dispatch<React.SetStateAction<PromoResultType>>;
  isValid : boolean;
}

const ButtonResultAddInterest = ({setTab, isValid}:Props) => {
    const recent_date = usePromoAddInterest((state)=>state.recent_date)
    const major = usePromoAddInterest((state)=>state.major)
    const name = usePromoAddInterest((state)=>state.name)
    const phone = usePromoAddInterest((state)=>state.phone)
    const birth_date = usePromoAddInterest((state)=>state.birth_date)
    const gender = usePromoAddInterest((state)=>state.gender)
    const memo = usePromoAddInterest((state)=>state.memo)
    const promotion_id = usePromoAddInterest((state)=>state.promotion_id)
    const school_class = usePromoAddInterest((state)=>state.school_class)
    const type = usePromoAddInterest((state)=>state.type)

    const reset = usePromoAddInterest((state)=>state.reset)
    
    useEffect(()=>{
      return()=>{
        reset()
      }
    },[])

    const handleResultAdd = async()=>{
        const fromat_date = format(recent_date, 'yyyy-MM-dd');
        const fromat_date2 = format(birth_date, 'yyyy-MM-dd');
        //보완 학교 이름 : 아이디 키 밸류 쌍 API 없음
        const response = await postInterestStudent(
            {promotion_id: promotion_id
              ,name: name
              ,birthday : fromat_date2
              ,gender : gender
              ,input_date :fromat_date
              ,phone : phone
              ,status : type
              ,memo: memo
              ,school_class : school_class
              ,major_name: major
        }
        )
        if(response.status === 'FAIL') return
        setTab('detail')
    }

  return (
    <NextButton onClick={()=>handleResultAdd()} disabled={!isValid}>추가</NextButton>
  )
}

export default ButtonResultAddInterest